<template>
    <b-btn class="color-tween-button" :variant="currentVariant" type="submit" :disabled="disabled" @click="onClicked">
        <template v-if="saving || loading">
            <slot name="loading">
                <loading-animation/>
                <span> {{ loadingText }}</span>
            </slot>
        </template>

        <template v-else-if="saved">
            <slot name="saved" :reset="reset">
                <success-icon/>
                <span> {{ savedText }}</span>
            </slot>
        </template>

        <template v-else-if="error">
            <slot name="error" :reset="reset">
                <error-icon/>
                <span> {{ errorText }}</span>
            </slot>
        </template>

        <template v-else-if="confirm">
            <slot name="confirm">
                <span> {{ confirmText }}</span>
            </slot>
        </template>

        <template v-else>
            <slot>
                <i :class="prependIcon" v-if="prependIcon"></i>
                <span> {{ text }}</span>
                <i :class="appendIcon" v-if="appendIcon"></i>
            </slot>
        </template>

    </b-btn>
</template>

<script>
import axios from 'secure-axios';

export default {
    name: 'loading-button',
    data () {
        return {
            saved: false,
            error: false,
            confirm: false,
            loading: false
        };
    },
    computed: {
        currentVariant () {
            if (this.saving) {
                return this.variant;
            }

            if (this.error) {
                return this.errorVariant;
            }

            if (this.saved) {
                return this.successVariant;
            }

            if (this.confirm) {
                return this.confirmVariant;
            }
            return this.variant;
        }
    },

    watch: {
        saveParams () {
            this.reset();
        }
    },

    props: {
        disabled: { type: Boolean, default: false, required: false },
        prependIcon: { type: String, default: '' },
        appendIcon: { type: String, default: '' },

        variant: { type: String, default: 'success' },
        errorVariant: { type: String, default: 'danger' },
        confirmVariant: { type: String, default: 'info' },
        successVariant: { type: String, default: 'success' },

        saving: { type: Boolean, default: false, required: false },

        text: { type: String, default: 'Save' },
        savedText: { type: String, default: 'Saved' },
        confirmText: { type: String, default: 'Confirm' },
        loadingText: { type: String, default: 'Saving...' },
        errorText: { type: String, default: 'Error Occured' },

        confirmRevert: { type: Boolean, default: true },
        confirmRevertInterval: { type: Number, default: 3000 },

        saveUrl: { type: String, default: '', required: false },
        saveParams: { type: Object, default: null, required: false },

        showConfirm: { type: Boolean, default: false },
        showErrorOnAjaxFailed: { type: Boolean, default: true },
        showSuccessOnAjaxComplete: { type: Boolean, default: true }
    },

    methods: {
        reset () {
            this.error = false;
            this.loading = false;
            this.success = false;
            this.confirm = false;
        },
        resetConfirm () {
            if (this.confirm === true) {
                this.reset();
            }
        },

        onClicked () {
            if (this.error || this.saved || this.loading || this.saving) {
                this.$emit('click');
                return;
            }

            const hasAjax = !!this.saveUrl;
            if (!hasAjax) {
                this.$emit('click');
            } else {
                if (!this.showConfirm) {
                    this.performAjax();
                } else {
                    if (this.confirm === true) {
                        this.performAjax();
                    } else {
                        this.confirm = true;
                        if (this.confirmRevert) {
                            setTimeout(this.resetConfirm, this.confirmRevertInterval);
                        }
                    }
                }
            }
        },

        performAjax () {
            const that = this;

            this.loading = true;
            this.saved = false;
            this.error = false;
            this.confirm = false;

            const saveUrl = this.saveUrl;
            let saveParams = this.saveParams;

            if (!saveParams) {
                saveParams = {};
            }

            axios.form(saveUrl, saveParams).then(function (response) {
                that.performAjaxSuccess(response);
            }).catch(function () {
                that.performAjaxError();
            });
        },

        performAjaxSuccess (response) {
            this.$emit('success', response.data);
            this.loading = false;
            if (this.showSuccessOnAjaxComplete) {
                this.saved = true;
            }
        },

        performAjaxError () {
            this.loading = false;
            if (this.showErrorOnAjaxFailed) {
                this.error = true;
            }
        }
    }
};
</script>
